import React from 'react'
import {
  Form, FormGroup,
  Card, CardHeader, CardBody
} from 'reactstrap'
import EmailEditor from 'react-email-editor'
import _ from 'lodash'

import Lang from 'Lang/General'

const EmailTemplate = ({
  emailEditorRef,
  onLoad,
  selectedLanguage
}) => {
  return(
    <Card className='mt-3'>
      <CardHeader>{ Lang[ 'EMAIL_TEMPLATE' ][ selectedLanguage ] }</CardHeader>
      <CardBody>
        <Form>
          <FormGroup>
            <p style={{ fontSize: '13px' }}>{ Lang[ 'EMAIL_TEMPLATE_MSG' ][ selectedLanguage ] }</p>
            <EmailEditor
              ref={ emailEditorRef }
              onLoad={ onLoad }
              options={{
                locale: selectedLanguage,
                features: {
                  stockImages: {
                    enabled: false
                  }
                },
                tools: {
                  image: {
                    properties: {
                      src: {
                        value: {
                          url: 'https://via.placeholder.com/500x100?text=IMAGE',
                          width: 500,
                          height: 100
                        }
                      }
                    }
                  },
                }
              }}
              projectId={ 28706 }
              style={{ overflow: 'auto' }}
            />
          </FormGroup>
        </Form>
      </CardBody>
    </Card>
  )
}

export default EmailTemplate